import { Box } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTextField from '../../CustomTextField';
import { XCircle } from '../../../icons/x-circle';
import STRING_KEYS from '../../../language/keys';
import SelectIcon from '../../SelectIcon';
import { VIEW_MODE } from '../../../consts/enums';
import { style } from './style';

type InsightLabelItemProps = {
  badges: BadgeItem[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDateValueChanged: (select: any, id: string) => void,
  companyId: string,
  disabled?: boolean,
  showClearButton?: boolean,
  viewMode: ViewMode
};

export const InsightLabelItem = ({
  badges = [], // backend sent undefined, 
  onDateValueChanged,
  companyId,
  disabled = false,
  showClearButton,
  viewMode,
}: InsightLabelItemProps):JSX.Element => {
  const { t: translate } = useTranslation();

  const isReadMode = viewMode === VIEW_MODE.READ_ONLY;

  const handleClearButtonClicked = () => {
    onDateValueChanged({
      badges: [{ iconUrl: '', text: '' }],
    }, companyId);
  };

  return (
    <Box sx={ isReadMode ? style.viewModeBoxRowLabel : style.boxRowLabel }>
      {(!isReadMode || badges[0]?.iconUrl) && (
        <Box sx={ style.boxRow }>
          <SelectIcon
            viewMode={ viewMode }
            imageUrl={ badges[0]?.iconUrl }
            onSelect={ (value: string) => {
              onDateValueChanged({
                badges:
            [{ iconUrl: value || '', text: badges[0]?.text }],
              }, companyId);
            } }
          />
        </Box>
      )}
      <CustomTextField
        style={ style.boxRow }
        sx={ style.boxRowMl }
        placeholder={ translate(STRING_KEYS.TITLE_LABEL) }
        fullWidth
        value={ badges[0]?.text }
        onChange={ (e:React.ChangeEvent<HTMLInputElement>) => {
          onDateValueChanged({
            badges: [{ iconUrl: badges[0]?.iconUrl || '', text: e.target.value }],
          }, companyId);
        } }
        disabled={ disabled }
        viewMode={ viewMode }
      />
      {(showClearButton && !isReadMode) && (
        <Box sx={ style.clearInsight.sx }>
          <XCircle
            onClick={ handleClearButtonClicked }
            sx={ style.clearInsight.sx }
          />
        </Box>
      )}
    </Box>
  );
};

InsightLabelItem.defaultProps = {
  disabled: false,
  showClearButton: false,
};
